<template>
  <q-page class="column">
    <GrTable
      :rows="temas"
      v-model:pagination="pagination"
      @del="excluirTema"
      @request="fetchTemaTablePage"
    />
  </q-page>
</template>

<script setup>
import GrTable from "@/components/gr/GrTable.vue";
import {
  baseUrlDelete,
  DELETE_FAILURE,
  DELETE_SUCCESS
} from "@/DemandasRepetitivas";
import { useAppStore } from "@/store/app-store";
import { useGRStore } from "@/store/gr-store";
import { useQuasar } from "quasar";
import { computed, watch, ref } from "vue";

const quasar = useQuasar();
const temaStore = useGRStore();
temaStore.fetchPage(1, 10);
const appStore = useAppStore();
appStore.drawerExpanded = true

const pagination = ref({
  sortBy: "desc",
  descending: false,
  page: 1,
  rowsPerPage: 10,
  get rowsNumber() {
    return temasCount.value;
  },
  set rowsNumber(v) {
    temasCount.value = v;
  }
});

const temasCount = computed(() => temaStore.temasCount);
const currentPage = computed(() => pagination.value?.page);
watch(temasCount, () => (pagination.value.rowsNumber = temasCount.value));
watch(currentPage, () => (temaStore.page = currentPage.value));

const temas = computed(() => temaStore.pages[pagination.value.page]);

const fetchTemaTablePage = props => {
  Object.assign(pagination.value, props.pagination);
  props.pagination.rowsPerPage = props.pagination.rowsPerPage == 0 ? temasCount.value : props.pagination.rowsPerPage;
  fetchTemasPage(props.pagination.page, props.pagination.rowsPerPage);
};

const search = () => fetchTemasPage(1);
const fetchTemasPage = (page = 1, rowsPerPage = 10) => temaStore.fetchPage(page, rowsPerPage);

const excluirTema = id => {
  const reload = search;
  const failure = () => notify(DELETE_FAILURE, "negative");
  const success = () => notify(DELETE_SUCCESS, "positive");

  const successAndReload = () => {
    success();
    reload();
  };
  const httpOk = r => r.status == 200;
  const readResponse = r => (httpOk(r) ? successAndReload() : failure());

  baseUrlDelete(`gruporepresentativo/${id}`)
    .then(readResponse)
    .catch(failure);
};

const notify = (msg, color) => {
  const notifyObj = (message, color) => ({ message, color });
  quasar.notify(notifyObj(msg, color));
};
</script>
